module.exports = __webpack_public_path__ + "01_glasses_red.fcb0015e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/01_glasses_red.png
// module id = l8DW
// module chunks = 0